export const vetMedicines = [
  {
    "name": "A TO Z NS (MULTIVITAMIN SYRUP)",
    "company": "Alkem"
  },
  {
    "name": "A-TOKAST 650mg (LINCOMYCIN DROPS)",
    "company": "Sun Pharma"
  },
  {
    "name": "A-TOPRAZOLE 30gm (LINCOMYCIN DROPS)",
    "company": "Micro Labs"
  },
  {
    "name": "ACECT 15ml (ORNIDAZOLE SPRAY)",
    "company": "Reckitt Benckiser"
  },
  {
    "name": "ACELOX 30gm (LIVER TONIC SUSPENSION)",
    "company": "Cipla"
  },
  {
    "name": "ACERIL 200ml (CETIRIZINE GEL)",
    "company": "Unichem"
  },
  {
    "name": "ACERIN 10ml (TERBINAFINE INHALER)",
    "company": "Cipla"
  },
  {
    "name": "ACESIL 10mg (PARACETAMOL SYRUP)",
    "company": "GSK"
  },
  {
    "name": "ACEZ 5ml (NORFLOXACIN DROPS)",
    "company": "Win-Medicare"
  },
  {
    "name": "ALLE52 100ml (METFORMIN DROPS)",
    "company": "Biocon"
  },
  {
    "name": "ALLECAL 500mg (AMLODIPINE POWDER)",
    "company": "Aurobindo"
  },
  {
    "name": "ALLECOR 20mg (VITAMIN E CAPSULE)",
    "company": "Micro Labs"
  },
  {
    "name": "ALLEDRYL 30gm (AZITHROMYCIN SUSPENSION)",
    "company": "Sanofi"
  },
  {
    "name": "ALLEGRA 120 (FEXOFENADINE TABLETS)",
    "company": "Sanofi"
  },
  {
    "name": "ALLEGRA 30ml (VITAMIN E TABLET)",
    "company": "Merck"
  },
  {
    "name": "ALLEMAC 10mg (METRONIDAZOLE OINTMENT)",
    "company": "Zuventus"
  },
  {
    "name": "ALLEMOL 250mg (SERRATIOPEPTIDASE CAPSULE)",
    "company": "Apex"
  },
  {
    "name": "ALLEMYCIN 20mg (FRAMYCETIN OINTMENT)",
    "company": "Wockhardt"
  },
  {
    "name": "ALLETRAL 50mg (BISOPROLOL SYRUP)",
    "company": "Eris"
  },
  {
    "name": "ALLEZINE 100mg (TERBINAFINE SUSPENSION)",
    "company": "Strides"
  },
  {
    "name": "AMACAL 30gm (ORNIDAZOLE SUSPENSION)",
    "company": "JB Chemicals"
  },
  {
    "name": "AMACOR 40mg (CEFIXIME OINTMENT)",
    "company": "Cadila"
  },
  {
    "name": "AMADRYL 1g (COUGH SYRUP CAPSULE)",
    "company": "Sanofi"
  },
  {
    "name": "AMADYN 250mg (MULTIVITAMIN INJECTION)",
    "company": "P&G"
  },
  {
    "name": "AMAKEM 40mg (BETAMETHASONE OINTMENT)",
    "company": "Zuventus"
  },
  {
    "name": "AMAKEM 50ml (LIVER TONIC INJECTION)",
    "company": "Alembic"
  },
  {
    "name": "AMARYL M2 (GLIMEPIRIDE & METFORMIN)",
    "company": "Sanofi"
  },
  {
    "name": "AMATUS 5ml (TETRACYCLINE INJECTION)",
    "company": "Zuventus"
  },
  {
    "name": "AMLOCAL 10ml (LIVER TONIC SPRAY)",
    "company": "Lupin"
  },
  {
    "name": "AMLOCID 50gm (ERYTHROMYCIN SPRAY)",
    "company": "GSK"
  },
  {
    "name": "AMLOCLOX 250mg (ORAL REHYDRATION SALTS OINTMENT)",
    "company": "Franco-Indian"
  },
  {
    "name": "AMLOCOR 400mg (CETIRIZINE SPRAY)",
    "company": "Indoco"
  },
  {
    "name": "AMLODRYL 1g (DOXYCYCLINE SUSPENSION)",
    "company": "Ajanta"
  },
  {
    "name": "AMLOKIND 5 (AMLODIPINE 5MG)",
    "company": "Mankind"
  },
  {
    "name": "AMO52 10ml (CEPHALEXIN CREAM)",
    "company": "Wockhardt"
  },
  {
    "name": "AMOCIN 15ml (MUPIROCIN CAPSULE)",
    "company": "Unichem"
  },
  {
    "name": "AMOFIN 250mg (FRAMYCETIN SPRAY)",
    "company": "Pfizer"
  },
  {
    "name": "AMOFLOX 30gm (LIVER TONIC SPRAY)",
    "company": "Ajanta"
  },
  {
    "name": "AMOPRAZOLE 100ml (DOMPERIDONE OINTMENT)",
    "company": "Eris"
  },
  {
    "name": "AMPDYN 15gm (MUPIROCIN CREAM)",
    "company": "Emcure"
  },
  {
    "name": "AMPGRA 40mg (FEXOFENADINE SUSPENSION)",
    "company": "Himalaya"
  },
  {
    "name": "AMPNORM 50gm (TETRACYCLINE TABLET)",
    "company": "Zydus"
  },
  {
    "name": "AMPPRAZOLE 10mg (CETIRIZINE POWDER)",
    "company": "Wockhardt"
  },
  {
    "name": "ASCODOL 10mg (OFLOXACIN DROPS)",
    "company": "Biocon"
  },
  {
    "name": "ASCOFENAC 30ml (CEPHALEXIN SUSPENSION)",
    "company": "Torrent"
  },
  {
    "name": "ASCONIZ 50gm (AMLODIPINE INJECTION)",
    "company": "Lupin"
  },
  {
    "name": "ASCOPRAZOLE 200ml (METFORMIN SYRUP)",
    "company": "Cadila"
  },
  {
    "name": "ASCORIL LS (EXPECTORANT SYRUP)",
    "company": "Glenmark"
  },
  {
    "name": "ASCOTRAL 200ml (METFORMIN CAPSULE)",
    "company": "Mankind"
  },
  {
    "name": "ASCOTUS 200mg (CEFIXIME OINTMENT)",
    "company": "FDC"
  },
  {
    "name": "ASCOVIT 200mg (PARACETAMOL SUSPENSION)",
    "company": "Torrent"
  },
  {
    "name": "AUGMENTIN 625 (AMOXICILLIN & CLAVULANATE)",
    "company": "GSK"
  },
  {
    "name": "AZICIN 650mg (METRONIDAZOLE SUSPENSION)",
    "company": "Apex"
  },
  {
    "name": "AZICT 250mg (PANTOPRAZOLE GEL)",
    "company": "Wallace"
  },
  {
    "name": "AZIFIN 50gm (VITAMIN B COMPLEX SPRAY)",
    "company": "GSK"
  },
  {
    "name": "AZIFLAM 5ml (TINIDAZOLE TABLET)",
    "company": "Alembic"
  },
  {
    "name": "AZIKIND 30ml (RABEPRAZOLE CAPSULE)",
    "company": "Indoco"
  },
  {
    "name": "AZIMA 100ml (ERYTHROMYCIN CREAM)",
    "company": "Strides"
  },
  {
    "name": "AZIMET 2g (KETOCONAZOLE INHALER)",
    "company": "GSK"
  },
  {
    "name": "AZIMOX 200mg (ERYTHROMYCIN OINTMENT)",
    "company": "Cipla"
  },
  {
    "name": "AZINORM 400mg (MUPIROCIN SYRUP)",
    "company": "Bayer"
  },
  {
    "name": "AZION 200ml (CEFUROXIME SPRAY)",
    "company": "Mankind"
  },
  {
    "name": "AZITHRAL 500 (AZITHROMYCIN TABLETS)",
    "company": "Alembic"
  },
  {
    "name": "BENA52 1g (DOXYCYCLINE GEL)",
    "company": "J&J"
  },
  {
    "name": "BENACET 650mg (CEFPODOXIME OINTMENT)",
    "company": "Dabur"
  },
  {
    "name": "BENACIN 30ml (OFLOXACIN CAPSULE)",
    "company": "Cadila"
  },
  {
    "name": "BENACT 250mg (CEPHALEXIN SYRUP)",
    "company": "Biocon"
  },
  {
    "name": "BENADRYL (COUGH SYRUP)",
    "company": "J&J"
  },
  {
    "name": "BENAKAST 100ml (BISOPROLOL DROPS)",
    "company": "P&G"
  },
  {
    "name": "BENAKEM 30ml (ANTACID INHALER)",
    "company": "Franco-Indian"
  },
  {
    "name": "BENAMYCIN 30gm (MUPIROCIN SUSPENSION)",
    "company": "Ajanta"
  },
  {
    "name": "BENARIL 5ml (DOXYCYCLINE GEL)",
    "company": "Biocon"
  },
  {
    "name": "BENARYL 50ml (TELMISARTAN SYRUP)",
    "company": "Dr. Reddy's"
  },
  {
    "name": "BENATUS 10mg (METFORMIN GEL)",
    "company": "J&J"
  },
  {
    "name": "BETCAL 10mg (CEFPODOXIME OINTMENT)",
    "company": "Panacea"
  },
  {
    "name": "BETCOR 500mg (TERBINAFINE SUSPENSION)",
    "company": "Dabur"
  },
  {
    "name": "BETGAL 100mg (CEFIXIME INHALER)",
    "company": "Cipla"
  },
  {
    "name": "BETGAL 400mg (DEXAMETHASONE GEL)",
    "company": "Reckitt Benckiser"
  },
  {
    "name": "BETGAL 500mg (CLOTRIMAZOLE SPRAY)",
    "company": "Mankind"
  },
  {
    "name": "BETLOX 200ml (KETOCONAZOLE CREAM)",
    "company": "Lupin"
  },
  {
    "name": "BETREX 20mg (PENICILLIN CAPSULE)",
    "company": "Himalaya"
  },
  {
    "name": "BETSIL 650mg (DOMPERIDONE INHALER)",
    "company": "Biocon"
  },
  {
    "name": "BETVIT 20mg (VITAMIN E INJECTION)",
    "company": "USV"
  },
  {
    "name": "BETZ 40mg (ITRACONAZOLE CREAM)",
    "company": "Strides"
  },
  {
    "name": "BETZINE 250mg (CEFDINIR TABLET)",
    "company": "Abbott"
  },
  {
    "name": "CALPOL 500 (PARACETAMOL TABLETS)",
    "company": "GSK"
  },
  {
    "name": "CANCET 5ml (CEFDINIR CAPSULE)",
    "company": "Pfizer"
  },
  {
    "name": "CANDID (CLOTRIMAZOLE DUSTING POWDER)",
    "company": "Glenmark"
  },
  {
    "name": "CANGRA 50gm (MULTIVITAMIN GEL)",
    "company": "Cadila"
  },
  {
    "name": "CANIM 5ml (DEXAMETHASONE INHALER)",
    "company": "Sun Pharma"
  },
  {
    "name": "CANKAST 50ml (PARACETAMOL INJECTION)",
    "company": "Sun Pharma"
  },
  {
    "name": "CANMAC 2g (DICLOFENAC DROPS)",
    "company": "Indoco"
  },
  {
    "name": "CANMYCIN 200ml (CALCIUM INJECTION)",
    "company": "Emcure"
  },
  {
    "name": "CANPRAZOLE 200mg (FRAMYCETIN DROPS)",
    "company": "Wallace"
  },
  {
    "name": "CEFCET 40mg (FRAMYCETIN OINTMENT)",
    "company": "Sanofi"
  },
  {
    "name": "CEFDDOL 15gm (BETAMETHASONE CAPSULE)",
    "company": "Strides"
  },
  {
    "name": "CEFDPRAZOLE 10ml (MULTIVITAMIN OINTMENT)",
    "company": "Pfizer"
  },
  {
    "name": "CEFDSIL 500mg (CETIRIZINE INJECTION)",
    "company": "Strides"
  },
  {
    "name": "CEFDTUS 400mg (CEFOTAXIME SUSPENSION)",
    "company": "Zuventus"
  },
  {
    "name": "CEFLINI 20mg (ERYTHROMYCIN CAPSULE)",
    "company": "Alkem"
  },
  {
    "name": "CEFOCID 400mg (LINCOMYCIN SUSPENSION)",
    "company": "Zydus"
  },
  {
    "name": "CEFODRYL 400mg (DICLOFENAC OINTMENT)",
    "company": "Himalaya"
  },
  {
    "name": "CEFODYN 40mg (AMLODIPINE POWDER)",
    "company": "Strides"
  },
  {
    "name": "CEFOFLAM 100mg (DOXYCYCLINE GEL)",
    "company": "Ipca"
  },
  {
    "name": "CEFOFLAM 400mg (DOXYCYCLINE SPRAY)",
    "company": "Torrent"
  },
  {
    "name": "CEFOMAC 50ml (COUGH SYRUP CREAM)",
    "company": "Eris"
  },
  {
    "name": "CEFON 500mg (DOMPERIDONE CAPSULE)",
    "company": "FDC"
  },
  {
    "name": "CEFOPRAZOLE 10ml (COUGH SYRUP SUSPENSION)",
    "company": "FDC"
  },
  {
    "name": "CEFOZOLE 15ml (METRONIDAZOLE SUSPENSION)",
    "company": "Ipca"
  },
  {
    "name": "CEFPFLAM 650mg (ERYTHROMYCIN SUSPENSION)",
    "company": "Apex"
  },
  {
    "name": "CEFPFLOX 15ml (CIPROFLOXACIN INHALER)",
    "company": "Zuventus"
  },
  {
    "name": "CEFPFLOX 30ml (VITAMIN B COMPLEX SYRUP)",
    "company": "Torrent"
  },
  {
    "name": "CEFPGRA 500mg (SERRATIOPEPTIDASE TABLET)",
    "company": "Indoco"
  },
  {
    "name": "CEFPMOX 30gm (CEFIXIME INJECTION)",
    "company": "Wockhardt"
  },
  {
    "name": "CEFPRAZOLE 50mg (FEXOFENADINE SPRAY)",
    "company": "Alkem"
  },
  {
    "name": "CEFTBION 500mg (OFLOXACIN SPRAY)",
    "company": "Sanofi"
  },
  {
    "name": "CEFTCAL 30gm (LINCOMYCIN INJECTION)",
    "company": "Apex"
  },
  {
    "name": "CEFTDRYL 50gm (LEVOCETIRIZINE INHALER)",
    "company": "Cadila"
  },
  {
    "name": "CEFTGRA 250mg (TERBINAFINE SUSPENSION)",
    "company": "Abbott"
  },
  {
    "name": "CEFTIM 5ml (VITAMIN B COMPLEX TABLET)",
    "company": "USV"
  },
  {
    "name": "CEFTMOL 200mg (VITAMIN B COMPLEX TABLET)",
    "company": "JB Chemicals"
  },
  {
    "name": "CEFTNIZ 50mg (SERRATIOPEPTIDASE SUSPENSION)",
    "company": "Reckitt Benckiser"
  },
  {
    "name": "CEFTRIN 200ml (ACECLOFENAC INJECTION)",
    "company": "JB Chemicals"
  },
  {
    "name": "CEFTRYL 200mg (FEXOFENADINE SYRUP)",
    "company": "Emcure"
  },
  {
    "name": "CEFU52 1g (SECNIDAZOLE INJECTION)",
    "company": "Dr. Reddy's"
  },
  {
    "name": "CEFUCID 100ml (TINIDAZOLE CREAM)",
    "company": "Torrent"
  },
  {
    "name": "CEFUGAL 10ml (CETIRIZINE INHALER)",
    "company": "Sanofi"
  },
  {
    "name": "CEFUIM 50mg (AZITHROMYCIN SUSPENSION)",
    "company": "J&J"
  },
  {
    "name": "CEFUIM 50mg (KETOCONAZOLE SUSPENSION)",
    "company": "Apex"
  },
  {
    "name": "CEFULOX 10ml (CETIRIZINE CREAM)",
    "company": "Zydus"
  },
  {
    "name": "CEFUMYCIN 50gm (IBUPROFEN SPRAY)",
    "company": "Wallace"
  },
  {
    "name": "CEPHCID 10mg (METRONIDAZOLE CREAM)",
    "company": "Dr. Reddy's"
  },
  {
    "name": "CEPHCLOX 10ml (ORAL REHYDRATION SALTS GEL)",
    "company": "Lupin"
  },
  {
    "name": "CEPHCT 400mg (OFLOXACIN SPRAY)",
    "company": "FDC"
  },
  {
    "name": "CEPHGRA 2g (TETRACYCLINE OINTMENT)",
    "company": "Dabur"
  },
  {
    "name": "CEPHRIL 650mg (METFORMIN SPRAY)",
    "company": "Dabur"
  },
  {
    "name": "CEPHTRAL 50mg (LEVOCETIRIZINE TABLET)",
    "company": "Biocon"
  },
  {
    "name": "CETICOR 20mg (MONTELUKAST DROPS)",
    "company": "Aristo"
  },
  {
    "name": "CETIMAC 50ml (FLUCONAZOLE GEL)",
    "company": "Wockhardt"
  },
  {
    "name": "CETIMOX 200mg (CEPHALEXIN SYRUP)",
    "company": "Glenmark"
  },
  {
    "name": "CETINORM 200mg (BETAMETHASONE SPRAY)",
    "company": "Indoco"
  },
  {
    "name": "CETIREX 40mg (VITAMIN E TABLET)",
    "company": "Biocon"
  },
  {
    "name": "CIPDOL 100mg (PANTOPRAZOLE POWDER)",
    "company": "J&J"
  },
  {
    "name": "CIPGRA 200ml (IBUPROFEN INHALER)",
    "company": "Bayer"
  },
  {
    "name": "CLOCID 15gm (CEFUROXIME CREAM)",
    "company": "Biocon"
  },
  {
    "name": "CLOCLOX 500mg (AMLODIPINE CAPSULE)",
    "company": "Ipca"
  },
  {
    "name": "CLOFIN 30ml (LINCOMYCIN SPRAY)",
    "company": "Zydus"
  },
  {
    "name": "CLOMOL 2g (PARACETAMOL SPRAY)",
    "company": "Dabur"
  },
  {
    "name": "CLOREX 50mg (SERRATIOPEPTIDASE TABLET)",
    "company": "Biocon"
  },
  {
    "name": "CLOTUS 400mg (PANTOPRAZOLE SPRAY)",
    "company": "Micro Labs"
  },
  {
    "name": "CLOVIT 10ml (ORNIDAZOLE SPRAY)",
    "company": "Himalaya"
  },
  {
    "name": "CLOVIT 200mg (PENICILLIN TABLET)",
    "company": "Alembic"
  },
  {
    "name": "COMBICID 30ml (ERYTHROMYCIN GEL)",
    "company": "Mankind"
  },
  {
    "name": "COMBICIN 250mg (ORAL REHYDRATION SALTS CAPSULE)",
    "company": "Indoco"
  },
  {
    "name": "COMBICLOX 5ml (LEVOCETIRIZINE INJECTION)",
    "company": "GSK"
  },
  {
    "name": "COMBICOR 40mg (CIPROFLOXACIN OINTMENT)",
    "company": "Eris"
  },
  {
    "name": "COMBIDID 15gm (ITRACONAZOLE GEL)",
    "company": "Cipla"
  },
  {
    "name": "COMBIFLAM (IBUPROFEN & PARACETAMOL)",
    "company": "Sanofi"
  },
  {
    "name": "COMBIMOL 500mg (TELMISARTAN GEL)",
    "company": "Ipca"
  },
  {
    "name": "COMBIRIL 30gm (ORAL REHYDRATION SALTS POWDER)",
    "company": "Bayer"
  },
  {
    "name": "COMBIRYL 50mg (ITRACONAZOLE INJECTION)",
    "company": "Micro Labs"
  },
  {
    "name": "CONCOR 5 (BISOPROLOL 5MG)",
    "company": "Merck"
  },
  {
    "name": "CONLINI 200mg (PANTOPRAZOLE INJECTION)",
    "company": "Panacea"
  },
  {
    "name": "CONMOX 2g (TINIDAZOLE DROPS)",
    "company": "Lupin"
  },
  {
    "name": "CONNIZ 200ml (TETRACYCLINE TABLET)",
    "company": "J&J"
  },
  {
    "name": "CONSIL 200mg (RABEPRAZOLE GEL)",
    "company": "Macleods"
  },
  {
    "name": "CONZ 50gm (THYROXINE SUSPENSION)",
    "company": "Zydus"
  },
  {
    "name": "CORCT 15gm (PENICILLIN CREAM)",
    "company": "Unichem"
  },
  {
    "name": "CORDYN 2g (CEFOTAXIME SYRUP)",
    "company": "GSK"
  },
  {
    "name": "COREX DX (COUGH SYRUP)",
    "company": "Pfizer"
  },
  {
    "name": "CORGAL 200mg (VITAMIN D3 TABLET)",
    "company": "Indoco"
  },
  {
    "name": "CORGRA 1g (CIPROFLOXACIN SYRUP)",
    "company": "Wockhardt"
  },
  {
    "name": "CROCIN (PARACETAMOL 500MG TABLETS)",
    "company": "GSK"
  },
  {
    "name": "DERMACAL 5ml (CEFIXIME SYRUP)",
    "company": "Abbott"
  },
  {
    "name": "DERMADID 15gm (PENICILLIN SYRUP)",
    "company": "Panacea"
  },
  {
    "name": "DERMALINI 30ml (BETAMETHASONE GEL)",
    "company": "Intas"
  },
  {
    "name": "DERMAMOL 15gm (FEXOFENADINE SPRAY)",
    "company": "Eris"
  },
  {
    "name": "DERMARIN 10ml (CALCIUM INHALER)",
    "company": "Emcure"
  },
  {
    "name": "DERMATUS 50mg (TERBINAFINE CAPSULE)",
    "company": "Torrent"
  },
  {
    "name": "DERMAV 50gm (PENICILLIN POWDER)",
    "company": "Wallace"
  },
  {
    "name": "DERMIKEM OC (ANTI-FUNGAL CREAM)",
    "company": "Alkem"
  },
  {
    "name": "DEXMOL 15gm (RABEPRAZOLE OINTMENT)",
    "company": "Merck"
  },
  {
    "name": "DEXREX 50mg (DEXAMETHASONE DROPS)",
    "company": "Biocon"
  },
  {
    "name": "DEXRYL 20mg (KETOCONAZOLE INHALER)",
    "company": "Sun Pharma"
  },
  {
    "name": "DICLOCT 2g (KETOCONAZOLE GEL)",
    "company": "Himalaya"
  },
  {
    "name": "DICLODYN 1g (CEFDINIR SPRAY)",
    "company": "Glenmark"
  },
  {
    "name": "DICLODYN 30ml (METRONIDAZOLE INJECTION)",
    "company": "Pfizer"
  },
  {
    "name": "DIGENE (ANTACID TABLETS/SYRUP)",
    "company": "Abbott"
  },
  {
    "name": "DIGIGENE 200ml (ORNIDAZOLE GEL)",
    "company": "Eris"
  },
  {
    "name": "DIGIKEM 400mg (CIPROFLOXACIN CREAM)",
    "company": "Wockhardt"
  },
  {
    "name": "DIGILOX 10mg (ANTACID SYRUP)",
    "company": "Abbott"
  },
  {
    "name": "DIGISIL 650mg (OMEPRAZOLE GEL)",
    "company": "Pfizer"
  },
  {
    "name": "DOLO 650 (PARACETAMOL 650MG TABLETS)",
    "company": "Micro Labs"
  },
  {
    "name": "DOLOGENE 500mg (DICLOFENAC TABLET)",
    "company": "Himalaya"
  },
  {
    "name": "DOLOMYCIN 200ml (THYROXINE OINTMENT)",
    "company": "Ajanta"
  },
  {
    "name": "DOLOZ 30ml (FRAMYCETIN POWDER)",
    "company": "Zydus"
  },
  {
    "name": "DOLOZOX 200mg (METFORMIN INHALER)",
    "company": "J&J"
  },
  {
    "name": "DOXFENAC 50gm (CEFPODOXIME INHALER)",
    "company": "Torrent"
  },
  {
    "name": "DOXMOX 10mg (TERBINAFINE SPRAY)",
    "company": "Apex"
  },
  {
    "name": "DOXZ 50ml (IBUPROFEN GEL)",
    "company": "Micro Labs"
  },
  {
    "name": "DOXZOX 15ml (PARACETAMOL SYRUP)",
    "company": "Dabur"
  },
  {
    "name": "ELECBION 400mg (LEVOCETIRIZINE POWDER)",
    "company": "Cipla"
  },
  {
    "name": "ELECCT 40mg (ORAL REHYDRATION SALTS INJECTION)",
    "company": "Lupin"
  },
  {
    "name": "ELECFLOX 10mg (MULTIVITAMIN SUSPENSION)",
    "company": "Micro Labs"
  },
  {
    "name": "ELECTRAL (ORAL REHYDRATION SALTS)",
    "company": "FDC"
  },
  {
    "name": "ELECTUS 10ml (CEFPODOXIME INJECTION)",
    "company": "Cadila"
  },
  {
    "name": "ELECZINE 30gm (LIVER TONIC CAPSULE)",
    "company": "Wallace"
  },
  {
    "name": "ENO (ANTACID POWDER)",
    "company": "GSK"
  },
  {
    "name": "ENOBION 5ml (CEFDINIR INJECTION)",
    "company": "Alembic"
  },
  {
    "name": "ENOCET 50gm (DOXYCYCLINE SUSPENSION)",
    "company": "Cipla"
  },
  {
    "name": "ENOCLOX 650mg (THYROXINE SPRAY)",
    "company": "Bayer"
  },
  {
    "name": "ENOCT 500mg (AMLODIPINE GEL)",
    "company": "Lupin"
  },
  {
    "name": "ENODERM 15gm (FEXOFENADINE SUSPENSION)",
    "company": "Sun Pharma"
  },
  {
    "name": "ENOFIN 400mg (CEFIXIME SPRAY)",
    "company": "Unichem"
  },
  {
    "name": "ENOFLOX 200ml (LEVOCETIRIZINE POWDER)",
    "company": "Aurobindo"
  },
  {
    "name": "ENOGAL 30ml (ORAL REHYDRATION SALTS GEL)",
    "company": "Torrent"
  },
  {
    "name": "ENOKEM 250mg (VITAMIN B COMPLEX DROPS)",
    "company": "J&J"
  },
  {
    "name": "ENOON 250mg (BISOPROLOL TABLET)",
    "company": "Cadila"
  },
  {
    "name": "ENOREX 250mg (CEFDINIR SYRUP)",
    "company": "Wallace"
  },
  {
    "name": "ENOV 200ml (TELMISARTAN CAPSULE)",
    "company": "P&G"
  },
  {
    "name": "ENOVIT 30gm (PANTOPRAZOLE CREAM)",
    "company": "Glenmark"
  },
  {
    "name": "ENOZOX 100ml (CEFTRIAXONE SPRAY)",
    "company": "Win-Medicare"
  },
  {
    "name": "ERYDRYL 50gm (THYROXINE CAPSULE)",
    "company": "Cipla"
  },
  {
    "name": "ERYMAC 15ml (BETAMETHASONE SUSPENSION)",
    "company": "Mankind"
  },
  {
    "name": "ERYNIZ 200ml (TERBINAFINE SPRAY)",
    "company": "USV"
  },
  {
    "name": "ERYREX 20mg (PANTOPRAZOLE DROPS)",
    "company": "J&J"
  },
  {
    "name": "ERYZ 100mg (CIPROFLOXACIN SUSPENSION)",
    "company": "Micro Labs"
  },
  {
    "name": "EVIOCT 2g (GLIMEPIRIDE TABLET)",
    "company": "Win-Medicare"
  },
  {
    "name": "EVIODRYL 400mg (CALCIUM CREAM)",
    "company": "Wallace"
  },
  {
    "name": "EVIOIM 100mg (NORFLOXACIN GEL)",
    "company": "Alembic"
  },
  {
    "name": "EVIOLINI 40mg (BETAMETHASONE SUSPENSION)",
    "company": "FDC"
  },
  {
    "name": "EVIOLOX 10mg (TERBINAFINE POWDER)",
    "company": "Wallace"
  },
  {
    "name": "EVIOMAC 50mg (THYROXINE INHALER)",
    "company": "Dabur"
  },
  {
    "name": "EVIOMYCIN 50mg (LEVOCETIRIZINE INJECTION)",
    "company": "Reckitt Benckiser"
  },
  {
    "name": "EVION 400 (VITAMIN E CAPSULES)",
    "company": "P&G"
  },
  {
    "name": "EVIOVIT 500mg (PARACETAMOL GEL)",
    "company": "Reckitt Benckiser"
  },
  {
    "name": "EVIOZ 500mg (DOMPERIDONE INHALER)",
    "company": "Pfizer"
  },
  {
    "name": "FLEXDID 10mg (CEFTRIAXONE POWDER)",
    "company": "Reckitt Benckiser"
  },
  {
    "name": "FLEXFIN 30gm (CEFUROXIME OINTMENT)",
    "company": "Wallace"
  },
  {
    "name": "FLEXGENE 1g (IBUPROFEN OINTMENT)",
    "company": "Lupin"
  },
  {
    "name": "FLEXKAST 650mg (VITAMIN D3 SUSPENSION)",
    "company": "P&G"
  },
  {
    "name": "FLEXON (IBUPROFEN & PARACETAMOL)",
    "company": "Aristo"
  },
  {
    "name": "FLEXV 30gm (ERYTHROMYCIN SYRUP)",
    "company": "Reckitt Benckiser"
  },
  {
    "name": "FLEXVIT 650mg (PARACETAMOL OINTMENT)",
    "company": "Merck"
  },
  {
    "name": "FLEXZINE 1g (IBUPROFEN INJECTION)",
    "company": "Zuventus"
  },
  {
    "name": "FLUDOL 15ml (VITAMIN D3 POWDER)",
    "company": "Reckitt Benckiser"
  },
  {
    "name": "FLUIM 20mg (OMEPRAZOLE CREAM)",
    "company": "Ipca"
  },
  {
    "name": "FLUMOX 200mg (AMOXICILLIN DROPS)",
    "company": "Pfizer"
  },
  {
    "name": "FOURCIN 50ml (METFORMIN OINTMENT)",
    "company": "Panacea"
  },
  {
    "name": "FOURCLOX 50gm (OFLOXACIN CAPSULE)",
    "company": "Lupin"
  },
  {
    "name": "FOURDERM (STEROID & ANTIBACTERIAL CREAM)",
    "company": "Cipla"
  },
  {
    "name": "FOURPRAZOLE 15ml (ACECLOFENAC POWDER)",
    "company": "Sun Pharma"
  },
  {
    "name": "FOURREX 10ml (CEFIXIME SUSPENSION)",
    "company": "Mankind"
  },
  {
    "name": "FOURSIL 20mg (AZITHROMYCIN SYRUP)",
    "company": "P&G"
  },
  {
    "name": "GELUCT 50ml (ORNIDAZOLE CAPSULE)",
    "company": "Torrent"
  },
  {
    "name": "GELUKAST 20mg (CEFTRIAXONE SPRAY)",
    "company": "Unichem"
  },
  {
    "name": "GELUKEM 2g (RABEPRAZOLE SYRUP)",
    "company": "JB Chemicals"
  },
  {
    "name": "GELULINI 1g (BETAMETHASONE TABLET)",
    "company": "Wockhardt"
  },
  {
    "name": "GELUSIL MPS (ANTACID SYRUP)",
    "company": "Pfizer"
  },
  {
    "name": "GLYCOFLAM 30gm (GLIMEPIRIDE TABLET)",
    "company": "JB Chemicals"
  },
  {
    "name": "GLYCOFLOX 200ml (THYROXINE OINTMENT)",
    "company": "Glenmark"
  },
  {
    "name": "GLYCOMET 500 (METFORMIN 500MG)",
    "company": "USV"
  },
  {
    "name": "GLYCOZOX 20mg (MULTIVITAMIN DROPS)",
    "company": "Panacea"
  },
  {
    "name": "GLYCOZOX 50gm (FLUCONAZOLE SYRUP)",
    "company": "Indoco"
  },
  {
    "name": "HONDYN 650mg (OMEPRAZOLE TABLET)",
    "company": "GSK"
  },
  {
    "name": "HONITUS (AYURVEDIC COUGH SYRUP)",
    "company": "Dabur"
  },
  {
    "name": "HONKAST 10mg (ACECLOFENAC DROPS)",
    "company": "Aurobindo"
  },
  {
    "name": "HONV 50gm (NORFLOXACIN OINTMENT)",
    "company": "Alembic"
  },
  {
    "name": "ITRADID 10ml (CEFPODOXIME SPRAY)",
    "company": "Himalaya"
  },
  {
    "name": "ITRAFIN 30ml (NORFLOXACIN OINTMENT)",
    "company": "Panacea"
  },
  {
    "name": "ITRAGRA 10mg (VITAMIN B COMPLEX SUSPENSION)",
    "company": "Merck"
  },
  {
    "name": "ITRATUS 250mg (CEFUROXIME GEL)",
    "company": "Intas"
  },
  {
    "name": "ITRAZ 50ml (BETAMETHASONE SUSPENSION)",
    "company": "Cipla"
  },
  {
    "name": "KETOCAL 10ml (LIVER TONIC POWDER)",
    "company": "Unichem"
  },
  {
    "name": "KETOCLOX 20mg (AMPICILLIN CREAM)",
    "company": "Zuventus"
  },
  {
    "name": "KETODID 100ml (OMEPRAZOLE GEL)",
    "company": "Glenmark"
  },
  {
    "name": "KETOFLAM 50ml (CIPROFLOXACIN SUSPENSION)",
    "company": "Cadila"
  },
  {
    "name": "KETOGRA 40mg (ERYTHROMYCIN TABLET)",
    "company": "Eris"
  },
  {
    "name": "KETOKAST 650mg (CEFDINIR GEL)",
    "company": "Merck"
  },
  {
    "name": "KETOPRAZOLE 250mg (BETAMETHASONE POWDER)",
    "company": "Merck"
  },
  {
    "name": "KETOZON 650mg (TERBINAFINE TABLET)",
    "company": "Panacea"
  },
  {
    "name": "LEVOFLAM 10mg (DOXYCYCLINE OINTMENT)",
    "company": "Eris"
  },
  {
    "name": "LEVOLINI 100mg (CIPROFLOXACIN INJECTION)",
    "company": "Abbott"
  },
  {
    "name": "LEVOLINI 10ml (VITAMIN B COMPLEX CREAM)",
    "company": "Franco-Indian"
  },
  {
    "name": "LEVORIL 10ml (PARACETAMOL SYRUP)",
    "company": "Zydus"
  },
  {
    "name": "LEVORYL 15gm (BISOPROLOL SUSPENSION)",
    "company": "P&G"
  },
  {
    "name": "LEVOXON 50mg (KETOCONAZOLE CREAM)",
    "company": "Panacea"
  },
  {
    "name": "LEVOZINE 10ml (CEFPODOXIME CREAM)",
    "company": "JB Chemicals"
  },
  {
    "name": "LEVOZON 2g (IBUPROFEN SYRUP)",
    "company": "Eris"
  },
  {
    "name": "LINCET 50ml (OMEPRAZOLE TABLET)",
    "company": "Macleods"
  },
  {
    "name": "LINFIN 100ml (DEXAMETHASONE SPRAY)",
    "company": "Aristo"
  },
  {
    "name": "LINFLOX 500mg (NORFLOXACIN POWDER)",
    "company": "Macleods"
  },
  {
    "name": "LINGAL 30ml (CIPROFLOXACIN INHALER)",
    "company": "Apex"
  },
  {
    "name": "LINMA 40mg (RABEPRAZOLE TABLET)",
    "company": "Ipca"
  },
  {
    "name": "LIV 52 (AYURVEDIC LIVER TONIC)",
    "company": "Himalaya"
  },
  {
    "name": "LIVDERM 650mg (ERYTHROMYCIN INJECTION)",
    "company": "Sanofi"
  },
  {
    "name": "LIVFIN 200mg (CEFOTAXIME DROPS)",
    "company": "Apex"
  },
  {
    "name": "LIVFIN 40mg (ERYTHROMYCIN DROPS)",
    "company": "GSK"
  },
  {
    "name": "LIVFLAM 1g (THYROXINE CREAM)",
    "company": "FDC"
  },
  {
    "name": "LIVMOX 20mg (ANTACID INJECTION)",
    "company": "Wallace"
  },
  {
    "name": "LIVTRAL 100mg (BISOPROLOL POWDER)",
    "company": "Macleods"
  },
  {
    "name": "LIVZINE 30gm (CEFPODOXIME SYRUP)",
    "company": "USV"
  },
  {
    "name": "LOXBION 50gm (LINCOMYCIN DROPS)",
    "company": "Win-Medicare"
  },
  {
    "name": "LOXDRYL 2g (BISOPROLOL POWDER)",
    "company": "Zydus"
  },
  {
    "name": "LOXMET 50mg (ORAL REHYDRATION SALTS CREAM)",
    "company": "Torrent"
  },
  {
    "name": "LOXRYL 100ml (NORFLOXACIN SPRAY)",
    "company": "Ipca"
  },
  {
    "name": "LOXVIT 10mg (COUGH SYRUP SUSPENSION)",
    "company": "Zydus"
  },
  {
    "name": "LOXZON 10mg (SECNIDAZOLE TABLET)",
    "company": "USV"
  },
  {
    "name": "METFENAC 50gm (ANTACID CREAM)",
    "company": "J&J"
  },
  {
    "name": "METGENE 650mg (CEFOTAXIME SYRUP)",
    "company": "Panacea"
  },
  {
    "name": "METGRA 20mg (PARACETAMOL OINTMENT)",
    "company": "Wallace"
  },
  {
    "name": "MONTINA L (LEVOCETIRIZINE & MONTELUKAST)",
    "company": "Aristo"
  },
  {
    "name": "MONTLOX 50gm (AMPICILLIN INJECTION)",
    "company": "Cadila"
  },
  {
    "name": "MONTTRAL 30gm (AMPICILLIN SYRUP)",
    "company": "Alembic"
  },
  {
    "name": "MOONIZ 15gm (VITAMIN B COMPLEX GEL)",
    "company": "Strides"
  },
  {
    "name": "MOOV (PAIN RELIEF CREAM)",
    "company": "Reckitt Benckiser"
  },
  {
    "name": "NEUROBION 10mg (CEPHALEXIN GEL)",
    "company": "Alembic"
  },
  {
    "name": "NEUROBION FORTE (VITAMIN B COMPLEX)",
    "company": "P&G"
  },
  {
    "name": "NEUROCID 10mg (VITAMIN B COMPLEX CREAM)",
    "company": "J&J"
  },
  {
    "name": "NEURODERM 100ml (THYROXINE SPRAY)",
    "company": "Himalaya"
  },
  {
    "name": "NEUROFLOX 1g (BISOPROLOL DROPS)",
    "company": "Pfizer"
  },
  {
    "name": "NEUROGAL 15ml (THYROXINE TABLET)",
    "company": "GSK"
  },
  {
    "name": "NEUROMAC 100ml (THYROXINE INJECTION)",
    "company": "Glenmark"
  },
  {
    "name": "NEUROSIL 15gm (CEFIXIME SUSPENSION)",
    "company": "Wockhardt"
  },
  {
    "name": "NEUROSIL 15ml (ORAL REHYDRATION SALTS DROPS)",
    "company": "Merck"
  },
  {
    "name": "NEUROTUS 200mg (PARACETAMOL TABLET)",
    "company": "Dabur"
  },
  {
    "name": "NEUROV 1g (TERBINAFINE OINTMENT)",
    "company": "Torrent"
  },
  {
    "name": "NEUROVIT 30ml (SECNIDAZOLE DROPS)",
    "company": "Franco-Indian"
  },
  {
    "name": "NORFIN 15gm (DOMPERIDONE GEL)",
    "company": "Wallace"
  },
  {
    "name": "NORIM 30gm (RABEPRAZOLE SUSPENSION)",
    "company": "Sanofi"
  },
  {
    "name": "NORLOX 30gm (BETAMETHASONE DROPS)",
    "company": "Glenmark"
  },
  {
    "name": "NORRIL 1g (DOXYCYCLINE SYRUP)",
    "company": "Dabur"
  },
  {
    "name": "NORRIL 20mg (DEXAMETHASONE INJECTION)",
    "company": "Merck"
  },
  {
    "name": "NORVIT 100ml (VITAMIN B COMPLEX SYRUP)",
    "company": "Dr. Reddy's"
  },
  {
    "name": "OFLFLAM 500mg (VITAMIN E TABLET)",
    "company": "Sanofi"
  },
  {
    "name": "OFLKIND 5ml (BISOPROLOL CAPSULE)",
    "company": "Mankind"
  },
  {
    "name": "OFLSIL 40mg (CEFUROXIME SYRUP)",
    "company": "Zydus"
  },
  {
    "name": "OFLSIL 50ml (TERBINAFINE SPRAY)",
    "company": "Abbott"
  },
  {
    "name": "OKACET (CETIRIZINE 10MG TABLETS)",
    "company": "Cipla"
  },
  {
    "name": "OKAMAC 100mg (THYROXINE GEL)",
    "company": "Ipca"
  },
  {
    "name": "OKAZ 2g (SERRATIOPEPTIDASE INHALER)",
    "company": "Torrent"
  },
  {
    "name": "OKAZOLE 50gm (CEPHALEXIN INJECTION)",
    "company": "Eris"
  },
  {
    "name": "OKAZOX 2g (AMPICILLIN DROPS)",
    "company": "J&J"
  },
  {
    "name": "OMEBION 500mg (BETAMETHASONE TABLET)",
    "company": "GSK"
  },
  {
    "name": "OMEE (OMEPRAZOLE 20MG CAPSULES)",
    "company": "Alkem"
  },
  {
    "name": "OMEMOX 50mg (CLOTRIMAZOLE INHALER)",
    "company": "Lupin"
  },
  {
    "name": "OMEON 650mg (VITAMIN B COMPLEX DROPS)",
    "company": "Bayer"
  },
  {
    "name": "OMEZOLE 400mg (VITAMIN D3 OINTMENT)",
    "company": "Wockhardt"
  },
  {
    "name": "ORNIDOL 5ml (LEVOCETIRIZINE TABLET)",
    "company": "Sun Pharma"
  },
  {
    "name": "ORNIGENE 50gm (CEFPODOXIME INJECTION)",
    "company": "Zydus"
  },
  {
    "name": "ORNIZ 1g (CLOTRIMAZOLE INJECTION)",
    "company": "Biocon"
  },
  {
    "name": "ORNIZINE 1g (ITRACONAZOLE TABLET)",
    "company": "Apex"
  },
  {
    "name": "ORS (ORAL REHYDRATION SALTS)",
    "company": "FDC"
  },
  {
    "name": "PAN 40 (PANTOPRAZOLE 40MG TABLETS)",
    "company": "Alkem"
  },
  {
    "name": "PAN D (PANTOPRAZOLE & DOMPERIDONE)",
    "company": "Alkem"
  },
  {
    "name": "PANTOFIN 100mg (RABEPRAZOLE TABLET)",
    "company": "Wockhardt"
  },
  {
    "name": "PANTOLINI 100mg (CALCIUM TABLET)",
    "company": "Torrent"
  },
  {
    "name": "PARACET 15ml (FLUCONAZOLE TABLET)",
    "company": "Eris"
  },
  {
    "name": "PARAMET 200ml (COUGH SYRUP DROPS)",
    "company": "Zydus"
  },
  {
    "name": "PARAXON 650mg (AMOXICILLIN OINTMENT)",
    "company": "Merck"
  },
  {
    "name": "PARAZOLE 200ml (BISOPROLOL SUSPENSION)",
    "company": "Mankind"
  },
  {
    "name": "PENCIN 650mg (AMPICILLIN SYRUP)",
    "company": "Cipla"
  },
  {
    "name": "PENCOR 1g (ACECLOFENAC SYRUP)",
    "company": "Aristo"
  },
  {
    "name": "PENLOX 500mg (DOXYCYCLINE INJECTION)",
    "company": "Emcure"
  },
  {
    "name": "PENON 650mg (AMLODIPINE SYRUP)",
    "company": "Glenmark"
  },
  {
    "name": "PENREX 100ml (CEFDINIR SUSPENSION)",
    "company": "P&G"
  },
  {
    "name": "RABECAL 100ml (CEFDINIR SPRAY)",
    "company": "Reckitt Benckiser"
  },
  {
    "name": "RABEFLAM 15ml (CEFPODOXIME INJECTION)",
    "company": "Pfizer"
  },
  {
    "name": "RABEON 200mg (CEPHALEXIN SUSPENSION)",
    "company": "Aurobindo"
  },
  {
    "name": "RABESIL 100mg (SERRATIOPEPTIDASE SUSPENSION)",
    "company": "USV"
  },
  {
    "name": "RABEV 30gm (LINCOMYCIN POWDER)",
    "company": "Zydus"
  },
  {
    "name": "RABEXON 50mg (CEFTRIAXONE CREAM)",
    "company": "Abbott"
  },
  {
    "name": "RABLET D (RABEPRAZOLE & DOMPERIDONE)",
    "company": "Lupin"
  },
  {
    "name": "SECBION 50ml (ITRACONAZOLE GEL)",
    "company": "Panacea"
  },
  {
    "name": "SECCET 200ml (LINCOMYCIN INHALER)",
    "company": "Cadila"
  },
  {
    "name": "SECCT 100mg (CETIRIZINE CAPSULE)",
    "company": "Zuventus"
  },
  {
    "name": "SECDOL 40mg (MULTIVITAMIN SPRAY)",
    "company": "Ipca"
  },
  {
    "name": "SECIM 200mg (LINCOMYCIN POWDER)",
    "company": "Panacea"
  },
  {
    "name": "SECXON 1g (GLIMEPIRIDE SYRUP)",
    "company": "Macleods"
  },
  {
    "name": "SHEL52 400mg (METFORMIN SUSPENSION)",
    "company": "J&J"
  },
  {
    "name": "SHELBION 15ml (CEFIXIME SUSPENSION)",
    "company": "Micro Labs"
  },
  {
    "name": "SHELDOL 30ml (CETIRIZINE INHALER)",
    "company": "Unichem"
  },
  {
    "name": "SHELIM 100mg (METFORMIN INJECTION)",
    "company": "Win-Medicare"
  },
  {
    "name": "SHELLINI 250mg (AZITHROMYCIN CREAM)",
    "company": "Panacea"
  },
  {
    "name": "SHELMOL 5ml (DOXYCYCLINE SUSPENSION)",
    "company": "Pfizer"
  },
  {
    "name": "SHELRYL 400mg (CEFIXIME GEL)",
    "company": "Wallace"
  },
  {
    "name": "SHELUCAL 500 (CALCIUM & VITAMIN D3)",
    "company": "Torrent"
  },
  {
    "name": "SHELVIT 50mg (MULTIVITAMIN DROPS)",
    "company": "Cadila"
  },
  {
    "name": "SHELZOX 100ml (CEFDINIR INHALER)",
    "company": "Aurobindo"
  },
  {
    "name": "SOFRACET 200mg (COUGH SYRUP SUSPENSION)",
    "company": "Glenmark"
  },
  {
    "name": "SOFRACLOX 50gm (KETOCONAZOLE POWDER)",
    "company": "Merck"
  },
  {
    "name": "SOFRADYN 500mg (NORFLOXACIN CAPSULE)",
    "company": "P&G"
  },
  {
    "name": "SOFRAMOX 200ml (PARACETAMOL SPRAY)",
    "company": "Ajanta"
  },
  {
    "name": "SOFRAMYCIN (FRAMYCETIN SKIN CREAM)",
    "company": "Sanofi"
  },
  {
    "name": "SOFRAREX 5ml (BETAMETHASONE SYRUP)",
    "company": "Strides"
  },
  {
    "name": "SOFRAZINE 500mg (MULTIVITAMIN DROPS)",
    "company": "Macleods"
  },
  {
    "name": "SOFRAZOX 200ml (SERRATIOPEPTIDASE GEL)",
    "company": "Merck"
  },
  {
    "name": "SUPRA52 100ml (LINCOMYCIN OINTMENT)",
    "company": "JB Chemicals"
  },
  {
    "name": "SUPRADYN (MULTIVITAMIN TABLETS)",
    "company": "Bayer"
  },
  {
    "name": "SUPRARIL 500mg (VITAMIN D3 GEL)",
    "company": "USV"
  },
  {
    "name": "SUPRATRAL 100mg (CALCIUM INJECTION)",
    "company": "Aristo"
  },
  {
    "name": "SUPRAZ 10mg (OFLOXACIN SPRAY)",
    "company": "Ajanta"
  },
  {
    "name": "SUPRAZOLE 2g (COUGH SYRUP INHALER)",
    "company": "Apex"
  },
  {
    "name": "SUPRAZON 2g (GLIMEPIRIDE OINTMENT)",
    "company": "GSK"
  },
  {
    "name": "T BACT (MUPIROCIN OINTMENT)",
    "company": "GSK"
  },
  {
    "name": "T-BABION 50gm (CIPROFLOXACIN SYRUP)",
    "company": "Zydus"
  },
  {
    "name": "T-BACID 500mg (VITAMIN E INHALER)",
    "company": "Apex"
  },
  {
    "name": "T-BACT 650mg (CLOTRIMAZOLE POWDER)",
    "company": "Eris"
  },
  {
    "name": "T-BAFLAM 500mg (ANTACID TABLET)",
    "company": "Ajanta"
  },
  {
    "name": "T-BAGENE 100mg (KETOCONAZOLE INHALER)",
    "company": "Unichem"
  },
  {
    "name": "T-BALOX 100mg (SECNIDAZOLE CREAM)",
    "company": "Sun Pharma"
  },
  {
    "name": "T-BAMOX 20mg (BETAMETHASONE OINTMENT)",
    "company": "Micro Labs"
  },
  {
    "name": "T-BANIZ 5ml (LEVOCETIRIZINE INJECTION)",
    "company": "GSK"
  },
  {
    "name": "T-BAZON 50mg (NORFLOXACIN SYRUP)",
    "company": "Apex"
  },
  {
    "name": "TAX52 250mg (CEFDINIR SUSPENSION)",
    "company": "Wockhardt"
  },
  {
    "name": "TAXCIN 15gm (VITAMIN B COMPLEX INHALER)",
    "company": "Aristo"
  },
  {
    "name": "TAXGAL 100ml (THYROXINE GEL)",
    "company": "FDC"
  },
  {
    "name": "TAXMA 200ml (ORAL REHYDRATION SALTS SUSPENSION)",
    "company": "FDC"
  },
  {
    "name": "TAXMA 50ml (RABEPRAZOLE GEL)",
    "company": "Alembic"
  },
  {
    "name": "TAXREX 200ml (BETAMETHASONE TABLET)",
    "company": "J&J"
  },
  {
    "name": "TAXSIL 200ml (FRAMYCETIN CAPSULE)",
    "company": "Wallace"
  },
  {
    "name": "TELCET 500mg (OFLOXACIN SUSPENSION)",
    "company": "Torrent"
  },
  {
    "name": "TELCIN 5ml (COUGH SYRUP CREAM)",
    "company": "Cadila"
  },
  {
    "name": "TELDOL 20mg (IBUPROFEN DROPS)",
    "company": "Biocon"
  },
  {
    "name": "TELDRYL 50gm (TINIDAZOLE INHALER)",
    "company": "Lupin"
  },
  {
    "name": "TELKIND 1g (AZITHROMYCIN SPRAY)",
    "company": "Franco-Indian"
  },
  {
    "name": "TELMA 40 (TELMISARTAN 40MG)",
    "company": "Glenmark"
  },
  {
    "name": "TELPRAZOLE 1g (METRONIDAZOLE OINTMENT)",
    "company": "Strides"
  },
  {
    "name": "TELXON 50gm (BISOPROLOL DROPS)",
    "company": "Franco-Indian"
  },
  {
    "name": "TELZOX 15gm (MULTIVITAMIN TABLET)",
    "company": "Pfizer"
  },
  {
    "name": "TERCIN 15gm (OMEPRAZOLE POWDER)",
    "company": "Glenmark"
  },
  {
    "name": "TERCIN 500mg (CEFIXIME SYRUP)",
    "company": "JB Chemicals"
  },
  {
    "name": "TERKAST 400mg (ITRACONAZOLE CREAM)",
    "company": "Macleods"
  },
  {
    "name": "TERMA 50ml (DICLOFENAC CAPSULE)",
    "company": "P&G"
  },
  {
    "name": "TERON 2g (IBUPROFEN OINTMENT)",
    "company": "Alkem"
  },
  {
    "name": "TERRIN 15gm (ORAL REHYDRATION SALTS GEL)",
    "company": "GSK"
  },
  {
    "name": "TERSIL 50ml (ITRACONAZOLE TABLET)",
    "company": "Torrent"
  },
  {
    "name": "TERXON 20mg (CIPROFLOXACIN SPRAY)",
    "company": "Alkem"
  },
  {
    "name": "TERZOX 200mg (ITRACONAZOLE SUSPENSION)",
    "company": "Wockhardt"
  },
  {
    "name": "TERZOX 50ml (CEFPODOXIME CAPSULE)",
    "company": "Himalaya"
  },
  {
    "name": "TETCET 650mg (LINCOMYCIN SUSPENSION)",
    "company": "Biocon"
  },
  {
    "name": "TETCIN 20mg (CEPHALEXIN SYRUP)",
    "company": "Strides"
  },
  {
    "name": "TETFLOX 40mg (THYROXINE INHALER)",
    "company": "Macleods"
  },
  {
    "name": "TETIM 100ml (VITAMIN D3 SYRUP)",
    "company": "Ipca"
  },
  {
    "name": "TETKIND 50mg (DEXAMETHASONE CAPSULE)",
    "company": "Win-Medicare"
  },
  {
    "name": "TETLOX 20mg (ORNIDAZOLE SYRUP)",
    "company": "Lupin"
  },
  {
    "name": "TETMA 2g (BETAMETHASONE INJECTION)",
    "company": "USV"
  },
  {
    "name": "TETMET 50mg (AMLODIPINE SUSPENSION)",
    "company": "Aurobindo"
  },
  {
    "name": "TETSIL 500mg (BETAMETHASONE INHALER)",
    "company": "Micro Labs"
  },
  {
    "name": "THYROFENAC 650mg (FRAMYCETIN INJECTION)",
    "company": "Apex"
  },
  {
    "name": "THYROGENE 10mg (VITAMIN B COMPLEX SPRAY)",
    "company": "Intas"
  },
  {
    "name": "THYROIM 50gm (LINCOMYCIN INJECTION)",
    "company": "Wallace"
  },
  {
    "name": "THYRONIZ 10ml (AMOXICILLIN SUSPENSION)",
    "company": "Aristo"
  },
  {
    "name": "THYRONORM 50 (THYROXINE 50MCG)",
    "company": "Abbott"
  },
  {
    "name": "THYROXON 15gm (GLIMEPIRIDE TABLET)",
    "company": "GSK"
  },
  {
    "name": "THYROZOX 50mg (TINIDAZOLE CAPSULE)",
    "company": "Torrent"
  },
  {
    "name": "TINBION 500mg (CETIRIZINE POWDER)",
    "company": "Alembic"
  },
  {
    "name": "TINMET 100ml (NORFLOXACIN INHALER)",
    "company": "Sun Pharma"
  },
  {
    "name": "TINMOX 400mg (DICLOFENAC INHALER)",
    "company": "Alembic"
  },
  {
    "name": "TINNIZ 2g (PENICILLIN POWDER)",
    "company": "Merck"
  },
  {
    "name": "TINSIL 10ml (CIPROFLOXACIN INHALER)",
    "company": "Intas"
  },
  {
    "name": "TINZOLE 250mg (PARACETAMOL INHALER)",
    "company": "Himalaya"
  },
  {
    "name": "TINZOX 50mg (MULTIVITAMIN SUSPENSION)",
    "company": "Cipla"
  },
  {
    "name": "VICKBION 200mg (TELMISARTAN CREAM)",
    "company": "Zuventus"
  },
  {
    "name": "VICKIM 200ml (LIVER TONIC GEL)",
    "company": "Aristo"
  },
  {
    "name": "VICKLINI 10mg (CEPHALEXIN INHALER)",
    "company": "Cadila"
  },
  {
    "name": "VICKMOL 40mg (CLOTRIMAZOLE INHALER)",
    "company": "FDC"
  },
  {
    "name": "VICKRYL 100mg (CALCIUM OINTMENT)",
    "company": "Cipla"
  },
  {
    "name": "VICKS VAPORUB",
    "company": "P&G"
  },
  {
    "name": "VICKZ 400mg (MUPIROCIN TABLET)",
    "company": "Torrent"
  },
  {
    "name": "VOLCET 200mg (METRONIDAZOLE GEL)",
    "company": "Cadila"
  },
  {
    "name": "VOLCET 50gm (COUGH SYRUP CAPSULE)",
    "company": "FDC"
  },
  {
    "name": "VOLCOR 40mg (COUGH SYRUP INHALER)",
    "company": "JB Chemicals"
  },
  {
    "name": "VOLDRYL 15gm (SERRATIOPEPTIDASE POWDER)",
    "company": "Zuventus"
  },
  {
    "name": "VOLIM 200ml (VITAMIN B COMPLEX CAPSULE)",
    "company": "Sanofi"
  },
  {
    "name": "VOLINI (DICLOFENAC GEL)",
    "company": "Sun Pharma"
  },
  {
    "name": "VOLLINI 15gm (CIPROFLOXACIN SPRAY)",
    "company": "Torrent"
  },
  {
    "name": "VOLNIZ 250mg (DICLOFENAC INJECTION)",
    "company": "Panacea"
  },
  {
    "name": "VOLNORM 15ml (DEXAMETHASONE INJECTION)",
    "company": "Zydus"
  },
  {
    "name": "ZEROCOR 400mg (LINCOMYCIN CAPSULE)",
    "company": "Intas"
  },
  {
    "name": "ZERODERM 100ml (LIVER TONIC CAPSULE)",
    "company": "Dr. Reddy's"
  },
  {
    "name": "ZERODERM 10mg (CIPROFLOXACIN DROPS)",
    "company": "Cadila"
  },
  {
    "name": "ZERODERM 50gm (METFORMIN CREAM)",
    "company": "Glenmark"
  },
  {
    "name": "ZERODOL SP (ACECLOFENAC, SERRATIOPEPTIDASE, PARACETAMOL)",
    "company": "Ipca"
  },
  {
    "name": "ZEROGAL 50mg (CIPROFLOXACIN POWDER)",
    "company": "Alembic"
  },
  {
    "name": "ZEROKIND 2g (LINCOMYCIN SYRUP)",
    "company": "Reckitt Benckiser"
  },
  {
    "name": "ZEROLOX 2g (MONTELUKAST SYRUP)",
    "company": "Strides"
  },
  {
    "name": "ZEROTRAL 15gm (BISOPROLOL OINTMENT)",
    "company": "Ipca"
  },
  {
    "name": "ZEROTUS 200ml (LIVER TONIC OINTMENT)",
    "company": "Dabur"
  },
  {
    "name": "ZEROXON 30ml (PARACETAMOL SPRAY)",
    "company": "Torrent"
  },
  {
    "name": "ZINCODERM 10ml (PENICILLIN POWDER)",
    "company": "Zuventus"
  },
  {
    "name": "ZINCOGRA 50ml (ORAL REHYDRATION SALTS INJECTION)",
    "company": "J&J"
  },
  {
    "name": "ZINCORIL 30ml (LINCOMYCIN INHALER)",
    "company": "Cadila"
  },
  {
    "name": "ZINCOSIL 15ml (METRONIDAZOLE INHALER)",
    "company": "Wallace"
  },
  {
    "name": "ZINCOTRAL 200ml (CIPROFLOXACIN TABLET)",
    "company": "Wockhardt"
  },
  {
    "name": "ZINCOVIT (MULTIVITAMIN SYRUP/TABLETS)",
    "company": "Apex"
  },
  {
    "name": "ZITCID 10mg (AMPICILLIN SPRAY)",
    "company": "GSK"
  },
  {
    "name": "ZITCOR 200ml (CEPHALEXIN SYRUP)",
    "company": "Indoco"
  },
  {
    "name": "ZITRIN 30gm (METFORMIN INHALER)",
    "company": "GSK"
  },
  {
    "name": "ZITZINE 1g (TELMISARTAN POWDER)",
    "company": "P&G"
  },
  {
    "name": "ALBANDA BOLUS 3GM (ALBENDAZOLE)",
    "company": "Intas Pharma"
  },
  {
    "name": "FENTAS BOLUS 1.5GM (FENBENDAZOLE)",
    "company": "Intas Pharma"
  },
  {
    "name": "NEOMEC BOLUS 100MG (IVERMECTIN)",
    "company": "Intas Pharma"
  },
  {
    "name": "NEOMEC INJECTION 10ML (IVERMECTIN)",
    "company": "Intas Pharma"
  },
  {
    "name": "NILZAN SUSPENSION 500ML (OXYCLOZANIDE + LEVAMISOLE)",
    "company": "Virbac Vet"
  },
  {
    "name": "CLOSANTEL BOLUS 1.5GM",
    "company": "Zydus Vet"
  },
  {
    "name": "FLOXIDIN INJECTION 100ML (ENROFLOXACIN)",
    "company": "Intas Pharma"
  },
  {
    "name": "INTACEF TAZO INJECTION 3.375GM (CEFTRIAXONE + TAZOBACTAM)",
    "company": "Intas Pharma"
  },
  {
    "name": "COBACTAN INJECTION 50ML (CEFQUINOME)",
    "company": "MSD Animal Health"
  },
  {
    "name": "TERRAMYCIN VET INJECTION 100ML (OXYTETRACYCLINE)",
    "company": "Zoetis"
  },
  {
    "name": "DICRISTICIN INJECTION 2.5GM (STREPTOPENICILLIN)",
    "company": "Zydus Vet"
  },
  {
    "name": "SULPHAMEZATHINE 33.3% INJECTION 100ML",
    "company": "Zoetis"
  },
  {
    "name": "MELONEX INJECTION 100ML (MELOXICAM)",
    "company": "Intas Pharma"
  },
  {
    "name": "MELONEX PLUS INJECTION 100ML (MELOXICAM + PARACETAMOL)",
    "company": "Intas Pharma"
  },
  {
    "name": "NIMOVET BOLUS (NIMESULIDE + PARACETAMOL)",
    "company": "Micro Labs Vet"
  },
  {
    "name": "VETALGIN INJECTION 100ML (ANALGIN)",
    "company": "MSD Animal Health"
  },
  {
    "name": "PREDEF 2X INJECTION 10ML (ISOFLUPREDONE)",
    "company": "Zoetis"
  },
  {
    "name": "DEXONA VET INJECTION 100ML (DEXAMETHASONE)",
    "company": "Zydus Vet"
  },
  {
    "name": "BELAMYL INJECTION 100ML (B-COMPLEX + LIVER EXTRACT)",
    "company": "Zydus Vet"
  },
  {
    "name": "CALBOROL INJECTION 450ML (CALCIUM BOROGLUCONATE)",
    "company": "Zoetis"
  },
  {
    "name": "CHELATED AGRIMIN FORTE POWDER 1KG",
    "company": "Virbac Vet"
  },
  {
    "name": "MINFA GOLD POWDER 1KG",
    "company": "Intas Pharma"
  },
  {
    "name": "CALUP GOLD LIQUID 1 LITER (CALCIUM)",
    "company": "Virbac Vet"
  },
  {
    "name": "UTEROTONE LIQUID 1 LITER",
    "company": "Himalaya Wellness Vet"
  },
  {
    "name": "BROTONE LIVER TONIC 1 LITER",
    "company": "Virbac Vet"
  },
  {
    "name": "LIV.52 VET LIQUID 1 LITER",
    "company": "Himalaya Wellness Vet"
  },
  {
    "name": "RUMENTAS POWDER 100GM (RUMEN BOOSTER)",
    "company": "Intas Pharma"
  },
  {
    "name": "FINADYNE INJECTION 50ML (FLUNIXIN MEGLUMINE)",
    "company": "MSD Animal Health"
  },
  {
    "name": "ZUBION INJECTION 20ML (BUPARVAQUONE)",
    "company": "Intas Pharma"
  },
  {
    "name": "BERENIL RTU INJECTION 90ML (DIMINAZENE)",
    "company": "MSD Animal Health"
  },
  {
    "name": "VETMATE INJECTION 2ML (CLOPROSTENOL)",
    "company": "Vetoquinol"
  },
  {
    "name": "RECEPTAL INJECTION 10ML (GNRH)",
    "company": "MSD Animal Health"
  },
  {
    "name": "CHORULON 1500 IU INJECTION (HCG)",
    "company": "MSD Animal Health"
  },
  {
    "name": "PENDISTRIN SH TEAT INFUSION 10ML",
    "company": "Zydus Vet"
  },
  {
    "name": "TAKTIC 12.5% LIQUID 100ML (AMITRAZ)",
    "company": "MSD Animal Health"
  },
  {
    "name": "BUTOX 1.25% LIQUID 100ML (DELTAMETHRIN)",
    "company": "MSD Animal Health"
  },
  {
    "name": "BAYTICOL POUR-ON 100ML (FLUMETHRIN)",
    "company": "Elanco"
  },
  {
    "name": "WISPREC SPRAY 100ML (FLY REPELLENT)",
    "company": "Intas Pharma"
  },
  {
    "name": "TOPICURE SPRAY 250ML",
    "company": "Natural Remedies"
  },
  {
    "name": "TIMPOL POWDER 100GM (BLOAT CARE)",
    "company": "Virbac Vet"
  },
  {
    "name": "AFANIL LIQUID 100ML (BLOAT CARE)",
    "company": "Himalaya Wellness Vet"
  },
  {
    "name": "HIMALAYAN BATISA POWDER 100GM",
    "company": "Himalaya Wellness Vet"
  },
  {
    "name": "MASTICURE BOLUS (MASTITIS CARE)",
    "company": "Intas Pharma"
  },
  {
    "name": "ERINA EP TICK & FLEA SHAMPOO 200ML",
    "company": "Himalaya Wellness Vet"
  },
  {
    "name": "BRAVECTO CHEWABLE TABLET FOR DOGS",
    "company": "MSD Animal Health"
  },
  {
    "name": "SIMPARICA TRIO TABLET FOR DOGS",
    "company": "Zoetis"
  },
  {
    "name": "NEXGARD SPECTRA TABLET FOR DOGS",
    "company": "Boehringer Ingelheim Vet"
  },
  {
    "name": "NUTRICOAT SYRUP FOR PETS 200ML",
    "company": "PetCare Vet"
  },
  {
    "name": "BELAMYL VET INJECTION 30ML",
    "company": "Zydus Animal Health"
  },
  {
    "name": "BELAMYL VET INJECTION 100ML",
    "company": "Zydus Animal Health"
  },
  {
    "name": "TRIBIVET INJECTION 100ML",
    "company": "Intas Animal Health"
  },
  {
    "name": "MELONEX PLUS INJECTION 100ML",
    "company": "Intas Animal Health"
  },
  {
    "name": "MELONEX PLUS BOLUS",
    "company": "Intas Animal Health"
  },
  {
    "name": "INTACEF 1GM INJECTION",
    "company": "Intas Animal Health"
  },
  {
    "name": "INTACEF TAZO 3.375GM INJECTION",
    "company": "Intas Animal Health"
  },
  {
    "name": "ATROPINE SULPHATE VET INJECTION 30ML",
    "company": "Neon Animal Health"
  },
  {
    "name": "DEXONA VET INJECTION 30ML",
    "company": "Zydus Animal Health"
  },
  {
    "name": "CALDEE-12 INJECTION 30ML",
    "company": "Zydus Animal Health"
  },
  {
    "name": "CALUP GEL 300GM",
    "company": "Virbac Animal Health"
  },
  {
    "name": "OSTOVET FORTE LIQUID 1L",
    "company": "Virbac Animal Health"
  },
  {
    "name": "VIMERAL LIQUID 120ML",
    "company": "Virbac Animal Health"
  },
  {
    "name": "CHELATED AGRIMIN FORTE 1KG",
    "company": "Virbac Animal Health"
  },
  {
    "name": "MINFA GOLD 1KG",
    "company": "Intas Animal Health"
  },
  {
    "name": "TOPICURE SPRAY 75ML",
    "company": "Natural Remedies"
  },
  {
    "name": "CHARMIL PLUS GEL 50GM",
    "company": "Dabur Ayurvet"
  },
  {
    "name": "CHARMIL PLUS SPRAY 100ML",
    "company": "Dabur Ayurvet"
  },
  {
    "name": "HIMAX OINTMENT 50GM",
    "company": "Indian Herbs"
  },
  {
    "name": "KISKIN CREAM 20GM",
    "company": "Intas Animal Health"
  },
  {
    "name": "POMISOL EAR DROPS 15ML",
    "company": "PetCare Animal Health"
  },
  {
    "name": "KIWOF PLUS TABLET FOR DOGS",
    "company": "Savavet"
  },
  {
    "name": "KIWOF PUPPY SUSPENSION 15ML",
    "company": "Savavet"
  },
  {
    "name": "DRONTAL PLUS TABLET FOR DOGS",
    "company": "Elanco Animal Health"
  },
  {
    "name": "ALBOMAR SUSPENSION 1000ML",
    "company": "Virbac Animal Health"
  },
  {
    "name": "BUTOX LIQUID 50ML",
    "company": "MSD Animal Health"
  },
  {
    "name": "TAKTIC 12.5% AMITRAZ 50ML",
    "company": "MSD Animal Health"
  },
  {
    "name": "NOTIX TICK & FLEA SHAMPOO 200ML",
    "company": "PetCare Animal Health"
  },
  {
    "name": "EXAPAR LIQUID 500ML",
    "company": "Dabur Ayurvet"
  },
  {
    "name": "UTRITONE LIQUID 500ML",
    "company": "Indian Herbs"
  },
  {
    "name": "MASTILEP GEL 125GM",
    "company": "Dabur Ayurvet"
  }
];
